import { ActionTypes } from "store/constants";

const initPayload = {
    open: false,
    questions: [],
    selectQnaOpen: null
}

export const worksheetViewReducer = (state = initPayload, action) => {
    switch (action.type) {
        case ActionTypes.worksheetView.set_worksheetView:
            return { ...state, ...action.payload};
        default:
            return state;
    }
};